import { AccountInfo } from '@azure/msal-browser';
import {
  GET_ROLE_ERROR,
  GET_ROLE_SUCCESS,
  GET_ROLE_REQUEST,
  SET_ACCOUNT,
  GET_ACCOUNT,
  CLEAR_ROLE_ERROR,
  SWITCH_USER_ROLE,
} from './constants';
import { Role } from '../../../../entities/Roles';

export const getRoleRequest = () => ({
  type: GET_ROLE_REQUEST,
});

export const getRoleSuccess = (role: Role) => ({
  type: GET_ROLE_SUCCESS,
  payload: { role },
});

export const getRoleError = (error: any) => ({
  type: GET_ROLE_ERROR,
  payload: { error },
});

export const clearRoleError = () => ({
  type: CLEAR_ROLE_ERROR,
});

export const setAccount = (account: AccountInfo | null) => ({
  type: SET_ACCOUNT,
  payload: { account },
});

export const getAccount = () => ({
  type: GET_ACCOUNT,
});

export const switchUserRole = (role: Role) => ({
  type: SWITCH_USER_ROLE,
  payload: { role },
});

export type Actions =
  | ReturnType<typeof getRoleRequest>
  | ReturnType<typeof getRoleSuccess>
  | ReturnType<typeof getRoleError>
  | ReturnType<typeof getAccount>
  | ReturnType<typeof setAccount>
  | ReturnType<typeof clearRoleError>
  | ReturnType<typeof switchUserRole>;
